import * as React from "react";
import * as PropTypes from "prop-types";

import { obfuscateAmount } from "utils";
import styles from "./FeesFooter.module.css";
import feesStyles from "../Fees.module.css";
import FeatureRenderer from "components/Feature/RendererContainer";

const FeesFooter = ({ totalPaid, totalRefunded, state }) => (
  <footer>
    {
    state !== "California" && <p className={styles.paidFooter}>
      <span className={styles.label}>Total Fees Paid: </span>
      <FeatureRenderer feature="FeeReportGeneration">
        <span className={styles.paid} id="TotalFeesPaid" name="Total Fees Paid">{totalPaid}</span>
      </FeatureRenderer>
      <FeatureRenderer feature="FeeReportGeneration" value={false} showUnset>
        <span className={`${styles.paid} ${feesStyles.blurred}`}>
          {obfuscateAmount(totalPaid)}
        </span>
      </FeatureRenderer>
    </p>
    }
    <p className={styles.refundedFooter}>
      <span className={styles.label} >Total Fees Refunded: </span>
      <FeatureRenderer feature="FeeReportGeneration">
        <span className={styles.refunded} id="TotalFeesRefunded" name="Total Fees Refunded">{totalRefunded}</span>
      </FeatureRenderer>
      <FeatureRenderer feature="FeeReportGeneration" value={false} showUnset>
        <span className={`${styles.refunded} ${feesStyles.bigBlurred}`}>
          {obfuscateAmount(totalRefunded)}
        </span>
      </FeatureRenderer>
    </p>
  </footer>
);

FeesFooter.propTypes = {
  totalPaid: PropTypes.string.isRequired,
  totalRefunded: PropTypes.string.isRequired
};

export default FeesFooter;
